import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import ApprovalCard from "../../Atoms/Card/approvalCard/ApprovalCard";
import Loading from "../../Atoms/loading/Loading";
import "./Skills.css";

function Approvals() {
  const [pendingSkills, setPendingSkills] = useState([]);
  const [availiableSkills, setAvailiableSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [relod, setRelod] = useState(false);

  useEffect(() => {
    setPendingSkills([]);
    setLoading(true);
    const fetchData = async () => {
      try {
        const snapShot = await db
          .collection("Skills")
          .where("isApproved", "==", false)
          .get();
        snapShot.forEach((doc) => setPendingSkills((p) => [...p, doc.data()]));
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    fetchData();
  }, [relod]);

  useEffect(() => {
    setAvailiableSkills([]);
    const fetchData = async () => {
      try {
        const snapShot = await db
          .collection("HomePageData")
          .doc("ScreenData")
          .get();
        setAvailiableSkills(snapShot.data().SkillCategory);
      } catch (e) {
        console.log(e);
      }
    };
    fetchData();
  }, []);

  //   console.log(pendingSkills);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="skills__board">
          <h1 style={{ margin: 20 }}>
            {pendingSkills.length === 0
              ? "No approval pending"
              : "Pending Skills"}
          </h1>
          {pendingSkills.map((item, i) => (
            <ApprovalCard
              key={i}
              data={item}
              skillState={[availiableSkills, setAvailiableSkills]}
              relodState={[relod, setRelod]}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default Approvals;
